import type { ReactNode } from 'react';
import { tonePresets, type BadgeTone } from './badgeTones';

export type { BadgeTone } from './badgeTones';

interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  /** Compact variant for tight spaces (e.g. confidence chip in card corner). */
  small?: boolean;
  'data-testid'?: string;
}

export function Badge({
  children,
  tone = 'neutral',
  small = false,
  'data-testid': testId,
}: BadgeProps) {
  const preset = tonePresets[tone];
  return (
    <span
      data-testid={testId}
      style={{
        background: preset.bg,
        color: preset.color,
        fontSize: small ? 10 : 11,
        fontWeight: 600,
        padding: small ? '2px 8px' : '3px 10px',
        borderRadius: 4,
        display: 'inline-block',
        flexShrink: 0,
        letterSpacing: '0.02em',
      }}
    >
      {children}
    </span>
  );
}
